import underscored from 'underscore.string/underscored';

angular.module('gym.contacts').controller('RemovePaymentMethodCtrl', ["$scope", "$modalInstance", "$http", "gym", "contact", "paymentMethod", "provider", function($scope, $modalInstance, $http, gym, contact, paymentMethod, provider) {
  var paymentSystem;
  $scope.gym = gym;
  $scope.contact = contact;
  $scope.paymentMethod = paymentMethod;
  $scope.isStripe = provider === 'stripe';
  paymentSystem = gym.payment_system;
  $scope.contactsType = function(type) {
    return `${underscored(type)}s`;
  };
  $scope.unlinkThisContact = function() {
    var url;
    url = `${paymentMethod.getRestangularUrl()}/unlink_contact`;
    $scope.isLoading = true;
    return $http.delete(url).then(function() {
      return $modalInstance.close();
    }, function() {
      return $scope.isLoading = false;
    });
  };
  $scope.unlinkAllContacts = function() {
    $scope.isLoading = true;
    return paymentMethod.remove().then(function() {
      return $modalInstance.close();
    }, function() {
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
